import { ESymbolRoles } from '@Core/Reels/SymbolRoles';
import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { IPayTableSymbol } from '@GFTypes/Responses/AuthenticateResponse';
import { ESpecialGamesType } from '@GFTypes/SpecialGames';

export const getSpecialSymbolId = (gameType: number): number | undefined => {
    return gameInstance.gameStore.get(EGameStoreKeys.Features).specialGames?.[ESpecialGamesType.FREE_GAMES]?.[ESymbolRoles.SPECIAL_SYMBOL]?.get(gameType);
};

export const getSpecialSymbolConfig = (symbolId: number) => {
    return gameInstance.gameStore.get(EGameStoreKeys.AuthenticateGameConfig).symbols[0].find((symbol) => symbol.symbolId === symbolId);
};

export const getMinimumCountFromPaytable = (symbolConfig: IPayTableSymbol): number => {
    return Math.min(...(symbolConfig.paytable?.[0]?.count ?? []));
};

export const buildSelectionMaskFromPositions = (positions: number[][], visibleSymbols: number[][]): boolean[][] => {
    const selectionMask = createEmptySelectionMaskFromMatrix(visibleSymbols);

    for (const [reelIndex, rowIndex] of positions) {
        if (!selectionMask[reelIndex]) continue;

        selectionMask[reelIndex][rowIndex] = true;
    }

    return selectionMask;
};

export const createEmptySelectionMask = (numberOfReels: number, numberOfSymbolsPerReel: number): boolean[][] => {
    return Array.from({ length: numberOfReels }, () => Array.from({ length: numberOfSymbolsPerReel }, () => false));
};

export const createEmptySelectionMaskFromMatrix = <T>(matrix: T[][]): boolean[][] => {
    return matrix.map((column) => column.map(() => false));
};
